<template>
    <div>
        <OrderTableElementTable 
            max-items="10" 
            pagination
            sst
            :total="this.totalPage"
            :currentPage="this.numCurrentPage"
            :data="orders"
            @changePageOrder="changePageOrder"
            :key="this.offset"
            :class="showHideTable"
        >
            <template slot="thead">
                <vs-th
                    v-for="fil in field"
                    :sort-key="fil.field.split('.')[0]"
                >
                                <!-- :class="{ 'author-header': fil.field === 'author.username' }" -->

                    <!-- <div v-if="tab.key !== 'new' & fil.field !== 'author.username'"> -->
                    <!-- <div v-if="fil.field !== 'author.username' && tab.key !== 'new'"> -->
                        <div v-if="tab.key === 'new'">
                            <div v-if="fil.field === 'author.username' && $store.state.auth.role === 'admin'">
                                {{ $t('manager') }}
                            </div>
                            <div v-else>
                                {{ $t(fil.title) }}
                            </div>
                        </div>
                        <div v-else>
                            {{ $t(fil.title) }}
                        </div>
                    <!-- </div> -->
                </vs-th>
            </template>

            <template slot-scope="{ data }">
                <vs-tr
                    :key="indextr"
                    v-for="(tr, indextr) in data"
                    :class="[
                            frsColorRowRed(tr) ? 'frsColorRowRed' : '', 
                            frsColorRowOrange(tr) ? 'frsColorRowOrange' : '', 
                            hasDealToday(tr) ? 'deal-today' : ''
                        ]"
                >
                    <template v-for="fil in field">

                        <vs-td v-if="fil.field === 'id'">
                            <router-link :to="'ticket/' + tr.id">
                                {{ tr.id }}
                            </router-link>
                        </vs-td>

                        <vs-td v-else-if="fil.field === 'name'">
                            <router-link :to="'ticket/' + tr.id">
                                {{ tr.name }}
                            </router-link>
                        </vs-td>

                        <vs-td v-else-if="fil.field === 'client.full_name'">
                            <router-link :to="`${pathToClient}/${deepFind(tr, 'client.id')}`">
                                {{ deepFind(tr, fil.field) || '---' }}
                            </router-link>
                        </vs-td>

                        <vs-td v-else-if="fil.field === 'client.website'">
                            <div								
                                class="text-sm frsColorBackSite"
                                :style="`background-color: ${tr.client.highlightingBackground}; color: ${tr.client.highlightingText};`"
                            >
                                {{ tr.client.website }}
                            </div>
                        </vs-td>

                        <vs-td v-else-if="fil.field === 'author.username' && tab.key === 'new' && $store.state.auth.role === 'admin'">
                            <div v-if="tr.manager === null && tr.nextManager === null" class="frsColorNoManager">
                                {{ $t('noNextManager') }}
                            </div>
                            <div v-else-if="tr.nextManager !== null && tr.nextManager.id > 0"  class="frsColorNextManager">
                                {{ tr.nextManager.last_name }} {{ tr.nextManager.first_name }}
                            </div>
                            <div v-else-if="tr.manager.id > 0" class="frsColorManager">
                                {{ tr.manager.last_name }} {{ tr.manager.first_name }}
                            </div>
                        </vs-td>
                        <vs-td v-else-if="fil.field === 'author.username' && tab.key !== 'new'">
                            <router-link
                                v-if="tr[fil.field.split('.')[0]]"
                                :to="`${pathToAuthor}/${deepFind(tr, 'author.id')}`"
                                class="flex justify-center text-center"
                            >
                                {{ deepFind(tr, fil.field) || '---' }}
                            </router-link>
                        </vs-td>

                        <vs-td 
                            v-else-if="fil.field === 'chat_messages_count' && $store.state.auth.role !== 'author'"
                        >
                            <span
                                class="counter"
                                :class="{ warn: tr.is_chat_unread }"
                            >
                                {{ tr.chat_messages_count }}
                            </span>
                        </vs-td>

                        <vs-td v-else-if="fil.field === 'chat_author_messages_count'">
                            <span
                                class="counterAuthor"
                                :class="{ warn: tr.is_chat_author_unread }"
                            >
                                {{ tr.chat_author_messages_count }}
                            </span>
                        </vs-td>
                        <vs-td v-else-if="fil.field === 'due_date'">
                            <span class="text-sm">
                                {{ tr.due_date }}
                            </span>
                        </vs-td>
                        <vs-td v-else-if="fil.field === 'created'">
                            <span class="text-sm">
                                {{ tr.created }}
                            </span>
                        </vs-td>



                        <!-- <vs-td v-else-if="fil.field === 'subject'">
                            {{ $getDeep(tr.subject, subjects) }}
                        </vs-td>

                        <vs-td v-else-if="fil.field === 'work_type'">
                            {{ $getDeep(tr.work_type, works) }}
                        </vs-td>

                        <vs-td v-else-if="fil.field === 'quality_level'">
                            {{ $getDeep(tr.quality_level, levels) }}
                        </vs-td> -->

                        <vs-td v-else-if="fil.field === 'task'">
                            <span
                                class="task cursor-pointer"
                                v-if="tr[fil.field]"
                                @click="editTask(tr.id, tr.task)"
                            >{{ tr[fil.field].date_time | moment('DD.MM.YYYY') }}</span>
                            <span
                                class="task cursor-pointer"
                                @click="idOrder = tr.id;activePrompt = true"
                                v-else
                            >+</span>

                        </vs-td>
                        <vs-td v-else-if="tr[fil.field]">
                            {{ tr[fil.field] }}
                        </vs-td>
                        <vs-td v-else>
                            ...
                        </vs-td>
                    </template>

                </vs-tr>
            </template>
            <vs-prompt
                @cancel="date = ''"
                @accept="createTask"
                :active.sync="activePrompt"
                :title="$t('addTask')"
                :acceptText="$t('save')"
                :cancelText="$t('cancel')"
            >
                <div class="con-exemple-prompt">
                    <vx-input-group class="mb-4">
                        <div
                            class="vs-component vs-con-input-label vs-input vs-input-primary"
                        >
                            <label class="vs-input--label">{{ $t('chooseDate') }}</label>
                            <div class="vs-con-input"></div>
                            <vs-datepicker
                                v-model="date"
                                :key="'activePromptDate' + activePromptCounter"
                                format="dd.MM.yyyy"
                                v-validate="'required'"
                                type="datetime"
                                name="date"
                            ></vs-datepicker>
                        </div>
                        <span v-if="errors.first('date')" class="text-danger text-sm">
                            {{ $t('fieldFilledIncorrect') }}
                        </span>
                    </vx-input-group>
                    <div class="vs-component vs-con-input-label vs-input vs-input-primary">
                        <label class="vs-input--label">{{ $t('description') }}</label>
                        <div class="vs-con-input"></div>
                        <vs-textarea
                            v-model="about"
                            :key="'activePromptAbout' + activePromptCounter"
                            name="about"
                            v-validate="'required|min:3|max:300'"
                            rows="4"
                            class="mb-0"
                        />
                    </div>
                    <span v-if="errors.first('about')" class="text-danger text-sm">
                        {{ $t('fieldFilledIncorrect') }}
                    </span>
                </div>
            </vs-prompt>
            <vs-popup class="viewTask" :title="$t('taskView')" :active.sync="popupActiv">
                <div class="body" v-if="task.order">
                    <table>
                        <tr>
                            <td><b>{{ $t('date') }}</b></td>
                            <td>{{ task.date_time | moment("DD.MM.YYYY") }}</td>
                        </tr>
                        <tr>
                            <td><b>{{ $t('ticket') }}</b></td>
                            <td>
                                <router-link :to="'ticket/' + task.order.id">
                        <span @click="popupActiv = false">
                            №{{ task.order.id }}
                        </span>
                                </router-link
                                >
                            </td>
                        </tr>
                    </table>
                    <b>{{ $t('description') }}</b>
                    <p>
                        {{ task.description }}
                    </p>
                </div>
                <div class="footer" v-if="task">
                    <vs-button
                        color="danger"
                        :disabled="task.is_by_admin"
                        @click="closeTask(task.order, task.id)"
                    >
                        {{ task.is_by_admin ? $t('setByAdmin') : $t('delete') }}
                    </vs-button>

                    <vs-button
                        color="success"
                        @click="completeTask(task.order, task.id)"
                    >{{ $t('done') }}</vs-button>
                </div>
            </vs-popup>
        </OrderTableElementTable>
        <img src="@/assets/images/logo/loadingTable_v2.png"           
            :class="showHideDivLoading"
            class="loadingTable"
        >
    </div>
</template>

<script>
    // import AdminFilters from './AdminFilters';
    import Datepicker from "vuejs-datepicker";
    import databaseManager from "@/mixins/databaseManager";
    import notifier from "@/mixins/notifier";
    import orderHeadersList from "@/assets/configs/orderHeadersList";
    import OrderTableElementTable from "@/views/Tickets/OrderTableElementTable.vue";

    export default {
        name: "OrderTable",
        mixins: [databaseManager, notifier],
        props: {
            tab: { required: true },
            options: { required: true },
            managerFilter: { required: true },
            authorFilter: { required: true },
            searchLike: { required: true },
            searchPremium: { required: true },
        },
        components: {
            Datepicker,
		    // AdminFilters,
            orderHeadersList,
            OrderTableElementTable,
        },
        data() {
            return {
                date: new Date(),
                loadingTable: false,
                // off: "",
                // to: "",
                // search: "",
                // selectedManager: null,
                // selectedAuthor: null,
                // selectedClient: null,
                // selectedWork: null,
                // selectedLevel: null,
                orders: [],
                subjects: [],
                works: [],
                levels: [],
                task: {},
                tasks: [],
                popupActiv: false,
                activePrompt: false,
                activePromptCounter: 0,
                about: "",
			    field: [],
                totalPage: 0,
                offset: 0,
                numCurrentPage: 1,
            };
        },
        watch: {
            activePrompt(value) {
                if(value) return;
                this.date = new Date();
                this.about = '';
            },
        },

        computed: {
            minDate() {
                return new Date();
            },
            showHideTable() {
                if(this.loadingTable) {
                    return 'showHideTable_show';
                } else {
                    return 'showHideTable_hide';
                }
            },
            showHideDivLoading() {
                if(!this.loadingTable) {
                    return 'showHideTable_show';
                } else {
                    return 'showHideTable_hide';
                }
            },
            pathToAuthor() {
                if(this.$store.state.auth.role === "admin") {
                    return 'author';
                } else if(this.$store.state.auth.role === "manager") {
                    return 'authorM';
                }
            },
            pathToClient() {
                if(this.$store.state.auth.role === "admin") {
                    return 'client';
                } else if(this.$store.state.auth.role === "manager") {
                    return 'clientM';
                }
            },
            searchedOrders() {
                let output = {};
                for (let key in this.orders) {
                    output[key] = this.orders[key].filter(item => {
                        if (this.search === "") {
                            return true;
                        }

                        if (item.name !== null && item.name !== undefined) {
                            if (item
                                .name
                                .toLowerCase()
                                .indexOf(this.search.toLowerCase()) !== -1) {

                                return true;
                            }
                        }

                        const clientFullName = item.client.full_name;
                        if (typeof clientFullName === "string" && clientFullName !== "") {
                            if (clientFullName
                                .toLowerCase()
                                .indexOf(this.search.toLowerCase()) !== -1) {

                                return true;
                            }
                        }

                        const clientEmail = item.client.email;
                        if (typeof clientEmail === "string" && clientEmail !== "") {
                            if (clientEmail
                                .toLowerCase()
                                .indexOf(this.search.toLowerCase()) !== -1) {

                                return true;
                            }
                        }

                        if (item.id !== null && item.id !== undefined) {
                            if (item.id == this.search.toLowerCase()) {

                                return true;
                            }
                        }

                        return false;
                    });
                }

                return output;
            },
        },
        methods: {
            short: (str, maxlen) => str.length <= maxlen ? str : str.slice(0, maxlen) + ' ...',
            changePageOrder(val) {
                let newOffset = (val-1)*10;
                let requestOptions = {
                    limit: 10,
                    offset: newOffset,
                };

                this.filter(requestOptions);
                // console.log(requestOptions);
                this.offset = newOffset;
                this.numCurrentPage = val;
            },
            // hasDealToday(tr) {
            // 	if(!tr || !tr.task) return false;

            // 	const [date] = tr.task.date_time.split(" ");
            // 	const [year, month, day] = date.split("-");

            // 	const current = new Date();
            // 	const cYear = current.getFullYear();
            // 	let cMonth = current.getMonth() + 1;
            // 	cMonth = cMonth >= 10 ? cMonth : '0' + cMonth;
            // 	let cDay = current.getDate();
            // 	cDay = cDay >= 10 ? cDay : '0' + cDay;

            // 	return +year === +cYear
            // 		&& +month === +cMonth
            // 		&& +day === +cDay;
            // },
            frsColorRowRed(tr) {
                if(!tr) return false;

                if(tr.due_date != '') {
                    let dateTr = new Date(tr.due_date);
                    let dateNow = new Date();
                    if(dateNow > dateTr) {
                        return true;
                    } else {
                        return false;
                    }
                } else {
                    return false;
                }
            },
            frsColorRowOrange(tr) {
                if(!tr) return false;

                if(tr.due_date != '') {
                    let dateTr = new Date(tr.due_date);
                    let year = dateTr.getFullYear();
                    let month = dateTr.getMonth() + 1;
                    let day = dateTr.getDate();

                    let dateNow = new Date();
                    let cYear = dateNow.getFullYear();
                    let cMonth = dateNow.getMonth() + 1;
                    let cDay = dateNow.getDate();
                    
                    return +year === +cYear
                    && +month === +cMonth
                    && +day === +cDay;
                } else {
                    return false;
                }
            },
            hasDealToday(tr) {
                if(!tr || !tr.task) return false;

                const [date] = tr.task.date_time.split(" ");
                const [year, month, day] = date.split("-");

                const current = new Date();
                const cYear = current.getFullYear();
                let cMonth = current.getMonth() + 1;
                cMonth = cMonth >= 10 ? cMonth : '0' + cMonth;
                let cDay = current.getDate();
                cDay = cDay >= 10 ? cDay : '0' + cDay;

                return +year === +cYear
                    && +month === +cMonth
                    && +day === +cDay;
            },
            async editTask(orderId, task) {
                if (task === null || task === undefined) return;

                const fullInfo = (await this.$http.get(
                    `/${this.$store.state.auth.role}/task/view/${task.id}`
                )).data.data;

                this.task = {
                    id: task.id,
                    order: {id: orderId},
                    date_time: task.date_time,
                    description: task.description,
                    is_by_admin: fullInfo.is_by_admin,
                };

                this.popupActiv = true
            },
            async completeTask(order, taskId) {
                try {
                    await this.$http.post(
                        `/${this.$store.state.auth.role}/task/complete/${taskId}`, { is_completed: true }
                    );
                    this.notifySuccess(this.$t("completedSuccessfully"));
                    this.popupActiv = false;

                    const ticket = this.findTicketAnywhere(order.id);

                    if(!!ticket) {
                        ticket.task = null;
                    }
                } catch (e) {
                    this.notifyError(e.message);
                }
            },
            async closeTask(order, taskId) {
                try {
                    await this.$http.post(
                        "/" + this.$store.state.auth.role + "/task/delete/" + taskId
                    );
                    this.notifySuccess(this.$t("deletedSuccessfully"));

                    this.popupActiv = false;

                    const ticket = this.findTicketAnywhere(order.id);

                    if(!!ticket) {
                        ticket.task = null;
                    }

                } catch (e) {
                    this.notifyError(e.message);
                }
            },
            async createTask() {
                this.activePrompt = true
                if(await this.$validator.validateAll() !== true) { return; }

                try {
                    this.activePrompt = false;
                    this.activePromptCounter++;

                    const newTask = await this.dbCreateTask(this.date, this.about, this.idOrder);

                    this.about = "";
                    this.date = new Date();
                    this.popupActiv = false;

                    const ticket = this.findTicketAnywhere(this.idOrder);

                    if(!!ticket) {
                        ticket.task = newTask;
                    }

                    // this.moveTicketToTop(ticket.status, this.idOrder);
                    // this.sortTab(ticket.status);

                    this.notifySuccess(this.$t("addedSuccessfully"));

                } catch (e) {
                    this.notifyError(e.message)
                }
            },
            findTask(id) {
                let res = this.tasks.filter(
                    (task) => (task.order && task.order.id) === id
                )[0];
                return !!res ? res : null;
            },
            deepFind(obj, path) {
                if (!path) return "";
                let paths = path.split("."),
                    current = obj,
                    i;

                for (i = 0; i < paths.length; ++i) {
                    if (current[paths[i]] === undefined) {
                        return undefined;
                    } else {
                        current = current[paths[i]];
                    }
                }

                return current;
            },
            // pathToAuthor() {
            //     if(this.$store.state.auth.role === "admin") {
            //         return 'author';
            //     } else if(this.$store.state.auth.role === "manager") {
            //         return 'authorM';
            //     }
            // },
            async filter(options = null) {
                this.loadingTable = false;
				try {
                    let requestOptions = {
						limit: 10,
						offset: 0,
					};

					requestOptions.type = this.tab.key;

                    if(options != null) {
                        if(options.limit != null) {
                            requestOptions.limit = options.limit;
                        }
                        if(options.offset != null) {
                            requestOptions.offset = options.offset;
                        }
                    }

                    requestOptions.manager = this.managerFilter;
                    requestOptions.author = this.authorFilter;
                    requestOptions.name = this.searchLike;
                    if(this.searchPremium != null && this.searchPremium == true) {
						requestOptions.premium = '1';
					}

					let bigData = await this.dbGetFilteredTickets(requestOptions);

                    this.totalPage = bigData.count;

                    let newListOrders = [];
                    let iNumOrder = requestOptions.offset;
                    bigData.data.forEach(function(elem) {
                        newListOrders[iNumOrder] = elem;
                        iNumOrder++;
                    });
					this.orders  = newListOrders;

				} catch (e) {
					this.notifyError(e.message);
				} finally {
                    this.loadingTable = true;
                }
			},
        },
        created() {
            const role = this.$store.state.auth.role;
            const headers = orderHeadersList.getHeaders(role);
            this.field = headers.field;
            this.tabs = headers.tabs;
        },
        async mounted() {
            // console.log(this.tab.key);
            try {
                const role = this.$store.state.auth.role;

                // if (role === "author") {
                //     this.tasks = (await this.$http.get("/" + role + "/order")).data.data;
                // } else {
                //     this.tasks = (await this.$http.get("/" + role + "/task")).data.data;
                // }

                this.levels = (
                    await this.$http.get("/settings/get-quality-levels")
                ).data.data;

                this.works = (await this.$http.get("/settings/get-work-types")).data.data;
                this.subjects = (await this.$http.get("/settings/get-subjects")).data.data;

                await this.filter();
            } catch(e) {
                this.notifyError(e.message);
            }
        },
    };
</script>

<style lang="scss" scoped>
    .showHideTable_hide {
        opacity: 0;
        display: none;
    }
    .showHideTable_show {
        opacity: 1;
        display: block;
    }
    .loadingTable {
        position: absolute;
        top: calc(100% + 50px) !important;
        left: calc(50% - 50px) !important;
        // top: 70%;
        // left: 50%;
    }
    .frsColorManager {
        background-color: greenyellow;
        padding: 5px;
        border-radius: 5px;
        text-align: center;
    }
    .frsColorNextManager {
        background-color: rgb(252, 216, 149);
        padding: 5px;
        border-radius: 5px;
        text-align: center;
    }
    .frsColorNoManager {
        background-color: pink;
        padding: 5px;
        border-radius: 5px;
        text-align: center;
    }
    .frsColorRowOrange {
        background-color: rgb(252, 216, 149);
    }
    .frsColorRowRed {
        background-color: pink;
    }
    .frsColorBackSite {
        padding: 5px;
        border-radius: 5px;
    }
    .deal-today {
		background-color: #FBE3C5;
	}
</style>